import { extractPayload } from './apiResponseUtils';

export const readPayload = (response) => extractPayload(response?.data) || {};

export const asArray = (value, keys = []) => {
  if (Array.isArray(value)) return value;

  const defaultKeys = [
    'content',
    'items',
    'transactions',
    'orders',
    'services',
    'announcements',
    'serviceablePincodes',
    'pincodes',
  ];

  for (const key of [...keys, ...defaultKeys]) {
    if (Array.isArray(value?.[key])) {
      return value[key];
    }
  }

  return [];
};

export const formatMoney = (value, currencyLabel = 'Rs') => (
  `${currencyLabel} ${Number(value || 0).toFixed(2)}`
);

export const formatDateTime = (value, fallback = '-') => {
  if (!value) return fallback;

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? fallback : date.toLocaleString();
};
